import { gql } from "@apollo/client";

const DECLINE_OLA = gql`
  mutation declineOLA3($olaID: String!, $email: String!, $name: String!, $position: String!, $reason: String!, $institution: Int!, $status: String!) {
    declineOLA3(olaID: $olaID, email: $email, name: $name, position: $position, reason: $reason, institution: $institution, status: $status) 
  }
`;

export default DECLINE_OLA;
